import React, { useEffect } from "react";
import { useToken } from "../components/TokenProvider";
import { Navigate } from "react-router-dom";
import { useUser } from "../components/UserContext";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetail } from "../store/userSlice";

const PrivateRoutes = ({ children, isAdmin }) => {
  const { singleRecord } = useSelector((state) => state.users);
  const dispatch = useDispatch();
  const { accessToken, linkHash } = useToken();

  useEffect(() => {
    dispatch(getUserDetail());
  }, [dispatch]);

  const token = accessToken || localStorage.getItem("accessToken");
  const isSuperUser = singleRecord?.data?.is_superuser;

  if (!token) {
    return (
      <Navigate
        to={isAdmin ? "/admin/login" : `/assessment/${linkHash}`}
        replace
      />
    );
  }

  if (isAdmin) {
    return isSuperUser ? children : <Navigate to="/unauthorized" />;
  }

  return !isSuperUser ? children : <Navigate to="/admin/assessments" />;
};

export default PrivateRoutes;
